import { render } from "./ProductStockTab.vue?vue&type=template&id=9ad1fd2c&scoped=true&ts=true"
import script from "./ProductStockTab.vue?vue&type=script&lang=ts"
export * from "./ProductStockTab.vue?vue&type=script&lang=ts"

import "./ProductStockTab.vue?vue&type=style&index=0&id=9ad1fd2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad1fd2c"]])

export default __exports__